import { Question } from "react-bootstrap-icons";
import { defineConfig } from "../config";
import { authHeader } from "../helpers";
import { utilsService } from "./utils";
const { handleResponse } = utilsService;

export const orderService = {
  getAllOrders,
  getOrderById,
  deleteById,
  getDistinctByField
};

const { apiUrl, apiVer } = defineConfig.ORDER_SERVICE;

function getApiPath(){
  return (apiUrl + apiVer + "/order");
}

function getAllOrders (page, pageSize = 10, filters = {}, sorter = {}) {
  let queryParams = [];
  let sortType =  sorter.order === 'descend' ? 'desc' : 'asc';
  let sortValue = sorter.field || "creationDate"
  
  for (const key in filters) {
    if (filters[key] !== undefined && filters[key] !== null && filters[key] !== "") {
      if (Array.isArray(filters[key])) {
        queryParams.push(`${encodeURIComponent(key)}=${encodeURIComponent(filters[key].join(","))}`);
      } else {
        queryParams.push(`${encodeURIComponent(key)}=${encodeURIComponent(filters[key])}`);
      }
    }
  }

  const queryString = queryParams.length ? `?${queryParams.join("&")}` : "";
  const url = getApiPath() + "/all/" + page + "/" + pageSize + "/" + sortValue + "/" + sortType + queryString;

  const requestOptions = {
    method: "GET",
    headers: authHeader("application/json"),
  };

  return fetch(url, requestOptions)
    .then(handleResponse)
    .then((res) => {
      return res;
    });
} 

function getOrderById(id) {
  const url = getApiPath() + `/read/${id}`;

  const requestOptions = {
    method: "GET",
    headers: authHeader("application/json"),
  };

  return fetch(url, requestOptions)
    .then(handleResponse)
    .then((res) => {
      return res;
    });
}

function deleteById(id) {
  const url = getApiPath() + `/delete/${id}`;

  const requestOptions = {
    method: "DELETE",
    headers: authHeader("application/json")
  };

  return fetch(url, requestOptions)
    .then(handleResponse)
    .then((res) => {
      return res;
    });
}

function getDistinctByField(field){  
  const url = getApiPath() + `/all/filter/${field}`;

  const requestOptions = {
    method: "GET",
    headers: authHeader("application/json"),
  };

  return fetch(
    url,
    requestOptions
  )
    .then(handleResponse)
    .then(res => {
      return res;
    });
}